import * as webix from './@xbs/webix-pro'

window.webix = webix

require('./@xbs/pivot/pivot.js')

Vue.component('Pivot', () => import('./Pivot'))
Vue.component('PivotManagePresets', () => import('./PivotManagePresets'))